import { combineReducers, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';

import profile from './profile'
import route from './route'
import customer from './customer';

const reducers = combineReducers({
    profile,
    route,
    customer
})

const store = createStore(
    reducers,
    applyMiddleware(thunk)
)

export default store